import { initialUserAddressError } from "../Constants/Addresses.constants";
import { Types } from "../Constants/Types";
import AddressType from "../Interfaces/address.interface";

const AddressesReducer = (state: AddressType['status'] = { 
        address: undefined,
        addresses: [],
        laddresses: false,
        laddress: false,
        error: initialUserAddressError
    },
    action: AddressType['action']
    ) => {

    switch (action.type) {

        case Types.FETCH_ADDRESSES:
            return {...state, addresses: action.payload};

        case Types.FETCH_ADDRESS:
            return {...state, address: action.payload};

        case Types.START_ADDRESSES:
            return {...state, laddresses: true};

        case Types.END_ADDRESSES:
            return {...state, laddresses: false};
        
        case Types.ADD_ADDRESS:
            return {...state, addresses: [...state.addresses, action.payload]};

        case Types.UPDATE_ADDRESS:
            return {
                ...state, 
                addresses: state.addresses.map(address => 
                    address._id === action.payload._id ? action.payload : address
                )
            };

        case Types.DELETE_ADDRESS:
            return {
                ...state,
                addresses: state.addresses.filter(address => address._id !== action.payload)
            };

        case Types.ERROR_ADDRESS:
            return {...state, error: action?.payload ? {...state.error, [action?.field!]: action.payload} : {...state.error, [action?.field!]: null}};

        case Types.RESET_ADDRESS:
            return {...state, error: initialUserAddressError}

        default: 
            return state
    }
}

export default AddressesReducer;